import { useEffect, useRef, useState } from 'react';
import { faucetApi } from '../api/faucet';
import { useAppStore } from '../store/useAppStore';
import { Icon } from './Icon';
import { telegram } from '../lib/telegram';

// Кнопка «Депозит»: раз в 3 часа можно забрать бонус 500. Показывает обратный отсчёт.
export function FaucetButton() {
  const setBalance = useAppStore((s) => s.setBalance);
  const showToast = useAppStore((s) => s.showToast);

  const [nextAt, setNextAt] = useState<number | null>(null);
  const [canClaim, setCanClaim] = useState(false);
  const [busy, setBusy] = useState(false);
  const [now, setNow] = useState(Date.now());
  const notifiedRef = useRef(true); // не уведомлять при первой загрузке если уже доступно

  useEffect(() => {
    faucetApi
      .status()
      .then((s) => {
        setCanClaim(s.canClaim);
        setNextAt(new Date(s.nextAt).getTime());
        notifiedRef.current = true;
      })
      .catch(() => undefined);
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const remaining = nextAt ? nextAt - now : 0;

  useEffect(() => {
    if (!canClaim && nextAt && remaining <= 0) {
      setCanClaim(true);
      if (!notifiedRef.current) {
        notifiedRef.current = true;
        showToast('Бонус 500 снова доступен');
        telegram.notify('success');
      }
    }
  }, [remaining, canClaim, nextAt, showToast]);

  const fmt = (ms: number) => {
    const s = Math.max(0, Math.ceil(ms / 1000));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  };

  const claim = async () => {
    if (busy) return;
    if (!canClaim) {
      showToast(`Бонус через ${fmt(remaining)}`);
      return;
    }
    setBusy(true);
    try {
      const r = await faucetApi.claim();
      setBalance(r.newBalance);
      setCanClaim(false);
      setNextAt(new Date(r.nextAt).getTime());
      notifiedRef.current = false;
      showToast(`Бонус +${r.claimed}`);
      telegram.notify('success');
    } catch (e: any) {
      showToast(e?.response?.data?.message || 'Бонус недоступен', true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button className={`faucet-btn ${canClaim ? 'ready' : ''}`} onClick={claim} title="Бонус каждые 3 часа">
      <Icon name="gem" size={13} />
      <span className="tnum">{canClaim ? 'Депозит +500' : fmt(remaining)}</span>
    </button>
  );
}
